import styles from "./CategoryPage.module.css";
import Gallery from "./comp/Gallery";
import Header from "./comp/Header";
import PageAnimation from "../../Other/PageAnimation";
import { useContext, useEffect } from "react";
import ImageShow from "../../UI/ImageShow";
import DataContext from "../../store/data-context";
import { useParams } from "react-router";

export default function CategoryPage() {
  const dataCtx = useContext(DataContext);
  const slug = useParams().categorySlug;



  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <PageAnimation>
        <header>
          <Header
            category={
              dataCtx.categories.filter((e) => e.acf.lang_url === slug)[0]
            }
          />
        </header>
        <main>
          <Gallery
            category={
              dataCtx.categories.filter((e) => e.acf.lang_url === slug)[0]
            }
            pageData={dataCtx.pageData.categories}
          />
        </main>
      </PageAnimation>
    </>
  );
}
